import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { analytics } from './firebase';
import { logEvent } from 'firebase/analytics';
import LoadingScreen from './components/LoadingScreen/LoadingScreen';
import Header from './components/Header/Header';
import Footer from './components/Footer/Footer';
import Home from './pages/Home/Home';
import About from './pages/About/About';
import OriginalWork from './pages/OriginalWork/OriginalWork';
import CollectionPage from './pages/CollectionPage/CollectionPage';
import Prints from './pages/Prints/Prints';
import Events from './pages/Events/Events';
import Contact from './pages/Contact/Contact';
import './App.css';

function App() {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Log page view (only if analytics is configured)
    if (analytics) {
      try {
        logEvent(analytics, 'page_view');
      } catch (error) {
        console.warn('Analytics error:', error);
      }
    }

    // Show loading screen for 3 seconds
    const timer = setTimeout(() => {
      setLoading(false);
    }, 3000);

    return () => clearTimeout(timer);
  }, []);

  if (loading) {
    return <LoadingScreen />;
  }

  return (
    <Router>
      <div className="App">
        <Header />
        <main className="main-content">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/original-work" element={<OriginalWork />} />
            <Route path="/collection/:collectionId" element={<CollectionPage />} />
            <Route path="/prints" element={<Prints />} />
            <Route path="/events" element={<Events />} />
            <Route path="/contact" element={<Contact />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;

